import React from 'react';

import { lang } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';
import { MCError } from './MCText';

class TextAreaField extends React.PureComponent {
  onChanged = (e) => {
    const { name, onChange } = this.props;

    onChange(name, e.target.value);
  };

  onBlur = (e) => {
    const { name, onBlur } = this.props;

    if (onBlur) {
      onBlur(name, e.target.value);
    }
  };

  render() {
    let {
      label,
      rows,
      template = 6,
      value,
      name,
      placeholder,
      invalid,
      requiredErrorMessage = null,
      errorName = null,
      autoFocus = false,
      isOptional = false,
      inputTestId,
      onChange,
      onBlur,
      resize,
      ...other
    } = this.props;

    let error = invalid && invalid[name];
    const testId = inputTestId || (name ? `input-${name}` : undefined);
    const handleChange = typeof onChange === 'function' ? this.onChanged : undefined;
    const handleBlur = typeof onBlur === 'function' ? this.onBlur : undefined;
    if (error?.includes('required')) {
      if (requiredErrorMessage) {
        error = requiredErrorMessage;
      } else {
        errorName = errorName || label || name;
        error = lang.t(LANG_CONST.validation.required, { label: lang.t(errorName) });
      }
    }

    return (
      <div className={'mc-text-field-group template-' + template} {...other}>
        {label && (
          <label>
            {lang.t(label)}{' '}
            {isOptional && <span className={'mc-label-414'}>({lang.t(LANG_CONST.optional)})</span>}
          </label>
        )}
        <div className={'mc-input-box-cover'}>
          <textarea
            data-testid={testId}
            autoComplete='true'
            autoFocus={autoFocus}
            rows={rows}
            name={name}
            placeholder={lang.t(placeholder)}
            id={'mc-' + name}
            className={`mc-input-box ${invalid[name] ? 'invalid' : 'valid'}`}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            style={{ resize: resize ?? 'both' }}
          />
        </div>
        {error && <MCError error={error} label={label || errorName} />}
      </div>
    );
  }
}

export default TextAreaField;
